import type { BandRef } from '../../api/process'

/** 6800 → "68", 6839 → "68.39". */
export const pctShort = (bp: number) => (bp / 100).toFixed(bp % 100 === 0 ? 0 : 2)

/** "68–72%" for a band, "No range" without one. */
export function bandText(band: Pick<BandRef, 'minBp' | 'maxBp'> | null | undefined): string {
  if (!band || band.minBp === null || band.maxBp === null) return 'No range'
  return `${pctShort(band.minBp)}–${pctShort(band.maxBp)}%`
}
